import { Flex } from '@styles';
import styled from 'styled-components';

export const SlidingComponent = styled(Flex)`
  transition: top 0.5s ease-in-out;
`;
